// [BD feat] PDP Custom Layout — Food Element Tab Switcher

class BdFoodTab extends HTMLElement {
  connectedCallback() {
    this._tabs = Array.from(this.querySelectorAll('.bd-pdp__food-tab'));
    this._cards = Array.from(this.querySelectorAll('.bd-pdp__food-card'));
    if (!this._tabs.length || !this._cards.length) return;

    this._tabs.forEach((tab) => {
      tab.addEventListener('click', () => this._switchTab(tab));
    });
  }

  _switchTab(activeTab) {
    const targetId = activeTab.dataset.tabId;
    if (!targetId) return;

    this._tabs.forEach((tab) => {
      tab.classList.toggle('bd-pdp__food-tab--active', tab === activeTab);
      tab.setAttribute('aria-selected', tab === activeTab ? 'true' : 'false');
    });

    this._cards.forEach((card) => {
      card.classList.toggle('bd-pdp__food-card--active', card.dataset.cardId === targetId);
    });
  }
}

if (!customElements.get('bd-food-tab')) {
  customElements.define('bd-food-tab', BdFoodTab);
}

// [BD feat] PDP Custom Layout — Food Element Tab Switcher

// [BD feat] PDP Custom Layout — Modal Trigger

class BdModalTrigger extends HTMLElement {
  connectedCallback() {
    this._btn = this.querySelector('.bd-modal-trigger');
    this._modal = this.querySelector('.bd-modal');
    if (!this._btn || !this._modal) return;

    // Teleport modal to <body> so position:fixed works from the viewport,
    // not from a transformed/stacking ancestor inside the product section.
    document.body.appendChild(this._modal);

    this._closeBtn = this._modal.querySelector('.bd-modal-close');
    this._backdrop = this._modal.querySelector('.bd-modal-backdrop');

    this._btn.addEventListener('click', () => this._open());
    if (this._closeBtn) this._closeBtn.addEventListener('click', () => this._close());
    if (this._backdrop) this._backdrop.addEventListener('click', () => this._close());

    this._keyHandler = (e) => { if (e.key === 'Escape') this._close(); };
    document.addEventListener('keydown', this._keyHandler);
  }

  disconnectedCallback() {
    // Remove the body-appended modal when component is destroyed
    if (this._modal && this._modal.parentNode === document.body) {
      document.body.removeChild(this._modal);
    }
    document.removeEventListener('keydown', this._keyHandler);
  }

  _open() {
    if (!this._modal) return;
    this._modal.hidden = false;
    document.body.style.overflow = 'hidden';
    // Two rAF frames ensure the browser paints the element before the
    // transition starts (hidden → translateY(0) in one frame causes no animation)
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this._modal.classList.add('bd-modal--open');
        const firstFocusable = this._modal.querySelector('button, [tabindex]');
        if (firstFocusable) firstFocusable.focus();
      });
    });
  }

  _close() {
    if (!this._modal) return;
    this._modal.classList.remove('bd-modal--open');
    this._modal.addEventListener('transitionend', () => {
      this._modal.hidden = true;
      document.body.style.overflow = '';
      this._btn.focus();
    }, { once: true });
  }
}

if (!customElements.get('bd-modal-trigger')) {
  customElements.define('bd-modal-trigger', BdModalTrigger);
}

// [BD feat] PDP Custom Layout — Modal Trigger
